// Contact page form -> POST /api/contact (functions/api/contact.js) -> Slack.
// Cloudflare Turnstile guards the submit when a site key is configured
// (data-turnstile-sitekey on the form root, from ENV TURNSTILE_SITEKEY or
// src/_data/site_metadata.yml). Without a site key the challenge is skipped
// and the API will answer "not configured yet" — the page still shows the
// support email as a fallback either way.
function loadTurnstileScript() {
  if (document.getElementById("turnstile-script")) return
  const script = document.createElement("script")
  script.id = "turnstile-script"
  script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js"
  script.async = true
  script.defer = true
  document.head.appendChild(script)
}

function initContactForm(root) {
  const form = root.querySelector("[data-contact-form]")
  const turnstileEl = root.querySelector("[data-turnstile]")
  const submitBtn = root.querySelector("[data-submit]")
  const successEl = root.querySelector("[data-success]")
  const errorEl = root.querySelector("[data-error]")
  const sitekey = root.dataset.turnstileSitekey || ""
  const readyLabel = submitBtn.dataset.readyLabel || "Send message"

  let cfToken = null
  let widgetId = null

  const setReady = () => {
    submitBtn.disabled = false
    submitBtn.textContent = readyLabel
  }
  const markVerified = (token) => {
    if (cfToken) return
    cfToken = token
    setReady()
  }

  if (sitekey) {
    loadTurnstileScript()
    const renderInterval = setInterval(() => {
      if (window.turnstile) {
        widgetId = window.turnstile.render(turnstileEl, { sitekey, callback: markVerified })
        clearInterval(renderInterval)
      }
    }, 200)
    // Fallback poll — the callback option doesn't always fire reliably.
    const pollInterval = setInterval(() => {
      if (cfToken) return clearInterval(pollInterval)
      if (widgetId !== null && window.turnstile) {
        const response = window.turnstile.getResponse(widgetId)
        if (response) markVerified(response)
      }
    }, 500)
  } else {
    turnstileEl.hidden = true
    setReady()
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault()
    errorEl.hidden = true
    successEl.hidden = true

    const name = form.querySelector('[name="name"]').value.trim()
    const email = form.querySelector('[name="email"]').value.trim()
    const message = form.querySelector('[name="message"]').value.trim()
    if (!name || !email || !message) {
      errorEl.textContent = "Please fill in all three fields."
      errorEl.hidden = false
      return
    }
    if (sitekey && !cfToken) {
      errorEl.textContent = "Please complete the security check above."
      errorEl.hidden = false
      return
    }

    submitBtn.disabled = true
    submitBtn.textContent = "Sending…"

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message, cfToken }),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`)

      form.reset()
      successEl.textContent = "Sent. We read everything and reply from a real inbox."
      successEl.hidden = false

      // Turnstile tokens are single-use; require a fresh check before the next send.
      cfToken = null
      if (sitekey) {
        submitBtn.disabled = true
        submitBtn.textContent = "Complete the security check above"
        if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId)
      } else {
        setReady()
      }
    } catch (err) {
      errorEl.textContent = err.message || "Something went wrong. Please try again."
      errorEl.hidden = false
      setReady()
    }
  })
}

document.querySelectorAll("[data-contact-form-root]").forEach(initContactForm)
